export default "__VITE_ASSET__BXmgOcj4__"